<div class="chart_container">
    <canvas #barChartWrapper></canvas>
</div>
